
import "./App.css";

import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import { LanguageProvider } from "./context/LanguageContext";

import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs";
import Services from "./pages/Services";
import Contact from "./pages/Contact";
import News from "./pages/News";
import NewsArticle from "./pages/NewsArticle";
import Editor from "./pages/Editor";
import TermsConditions from "./pages/TermsConditions";
import CookiePolicy from "./pages/CookiePolicy";

import CookieConsent from "./components/CookieConsent";
import SEOHead from "./components/SEOHead";

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          {/* SEO metadata for each page */}
          <SEOHead />

          <Routes>
            {/* Main pages */}
            <Route path="/" element={<Home />} />
            <Route path="/aboutus" element={<AboutUs />} />
            <Route path="/services" element={<Services />} />
            <Route path="/contact" element={<Contact />} />

            {/* Redirect old URLs */}
            <Route
              path="/about"
              element={<Navigate to="/aboutus" replace />}
            />

            <Route
              path="/mission"
              element={<Navigate to="/aboutus" replace />}
            />

            <Route
              path="/certifications"
              element={<Navigate to="/aboutus" replace />}
            />

            {/* News */}
            <Route path="/news" element={<News />} />
            <Route
              path="/news/:slug"
              element={<NewsArticle />}
            />

            {/* Editor */}
            <Route path="/editor" element={<Editor />} />
            <Route path="/edit" element={<Editor />} />

            {/* Legal pages */}
            <Route
              path="/terms"
              element={<TermsConditions />}
            />

            <Route
              path="/cookies"
              element={<CookiePolicy />}
            />
          </Routes>

          {/* Cookie consent */}
          <CookieConsent />
        </BrowserRouter>
      </div>
    </LanguageProvider>
  );
}

export default App;
